import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AppSettings } from '../app.settings';
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  public logout: Subject<any> = new Subject<any>();
  cookiesItems = [];

  constructor() { }

  getItem(key: string): any {
    const result = localStorage.getItem(key);
    let resultJson = null;
    if (result != null) {
      resultJson = result;
    }
    return resultJson;
  }

  setItem(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  setItemInCookies(key: string, value: string) {
    this.cookiesItems.push(key);
    const d = new Date();
    d.setTime(d.getTime() + AppSettings.COOKIE_EXPIRY);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${key}=${value};${expires};path=/`;
  }

  getItemFromCookies(key: string) {
    const name = `${key}=`;
    const ca = document.cookie.split(';');
    for (const c of ca) {
      let cookie = c;
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return '';
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  removeAll() {
    localStorage.clear();
  }

  removeAllCookies() {
    this.cookiesItems.forEach(key => {
      this.setItemInCookies(key, '');
    });
  }
}
